export default __webpack_public_path__ + "static/poc-785d76139348f452a746983af0b7f3f9.png";